
import { IAccount, CAccount } from './account';

export interface IAuth {
  mail: string;
  password: string;
  passwordConfirm: string;
  code: string;
}

export class CAuth implements IAuth {
  public mail = '';
  public password = '';
  public passwordConfirm = '';
  public code = '';
}

export interface INewAccount extends IAccount {
  sei: string;
  mei: string;
  seiKana: string;
  meiKana: string;
}

export class CNewAccount extends CAccount implements INewAccount {
  public sei = '';
  public mei = '';
  public seiKana = '';
  public meiKana = '';
}
